import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import Joyride from "react-joyride";
import CompanyStatusCheck from "./CompanyStatusCheck";
import moment from "moment";
import Search from "./Search";
import { toastr } from "react-redux-toastr";
import * as Constants from '../constants';

import Index from "./Index";
import { fetchEmailBroadcasts, cancelEmailBroadcast } from "../actions/index";
import EmailBroadcastsIndexTourSteps from "./tours/EmailBroadcastsIndexTourSteps";

export class EmailBroadcastsIndex extends Index {
  static propTypes = {
    fetchEmailBroadcasts: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    emailBroadcasts: PropTypes.object,
    cancelEmailBroadcast: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchEmailBroadcasts(
      this.serialize(newQueries)
    );
    this.props.history.push(`/eblasts${this.serialize(newQueries)}`);
  }

  cancelLink(emailBroadcast) {
    if (
      emailBroadcast.cancelled_at != null ||
      emailBroadcast.unhandled_count == 0
    ) {
      return "";
    } else {
      return (
        <button
          className="btn btn-xs btn-danger"
          onClick={this.handleCancelEmailBroadcast.bind(this)}
          data-id={emailBroadcast.id}
        >
          Cancel
        </button>
      );
    }
  }

  status(emailBroadcast) {
    if (emailBroadcast.cancelled_at != null) {
      return <span className="label label-default">Cancelled</span>;
    } else if (emailBroadcast.unhandled_count == 0) {
      return <span className="label label-success">Sent</span>;
    } else if (emailBroadcast.pause_delivery_until != null) {
      return <span className="label label-danger">Throttled</span>;
    } else if (emailBroadcast.delivery_window_starts_at != null) {
      return (
        <span className="label label-default">
          Scheduled for{" "}
          {moment(emailBroadcast.delivery_window_starts_at).format(
            "MM/DD/YYYY h:mm:ss A"
          )}
        </span>
      );
    } else {
      return <span className="label label-info">Sending</span>;
    }
  }

  handleCancelEmailBroadcast(e) {
    let eblastId = e.target.dataset.id;
    if (
      confirm(
        "Are you sure you want to cancel this eBlast?\nThis cannot be undone."
      )
    ) {
      this.props
        .cancelEmailBroadcast(eblastId)
        .then(() => {
          toastr.success("EBlast cancelled!");
          this.fetchData();
        });
    }
  }

  dropped_count(emailBroadcast) {
    return emailBroadcast.dropped_count;
  }

  renderEmailBroadcasts() {
    if (!this.props.emailBroadcasts.data) {
      return (
        <tr>
          <td colSpan={14}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.emailBroadcasts.data.length == 0) {
      return (
        <tr>
          <td colSpan={14}>
            <div className="well well-lg text-center">
              You have no eBlasts.&nbsp;
            </div>
          </td>
        </tr>
      );
    }

    return this.props.emailBroadcasts.data.map(emailBroadcast => {
      return (
        <tr key={emailBroadcast.id}>
          <td>
            <Link
              to={`/eblasts/${emailBroadcast.id}/emails?${Constants.DEFAULT_PAGINATION}`}
            >
              <strong>
                {moment(emailBroadcast.created_at).format(
                  "MM/DD/YYYY h:mm:ss A"
                )}
              </strong>
            </Link>
          </td>
          <td>{this.status(emailBroadcast)}</td>
          <td>{emailBroadcast.name}</td>
          <td>{emailBroadcast.subject}</td>
          <td className="text-right">
            {emailBroadcast.delivered_count > emailBroadcast.sent_emails_count
              ? emailBroadcast.delivered_count.toLocaleString()
              : emailBroadcast.sent_emails_count.toLocaleString()}
          </td>
          <td className="text-right">{emailBroadcast.delivered_count ? emailBroadcast.delivered_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.opened_count ? emailBroadcast.opened_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.clicked_count ? emailBroadcast.clicked_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.unsubscribed_count ? emailBroadcast.unsubscribed_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.complained_count ? emailBroadcast.complained_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.bounced_count ? emailBroadcast.bounced_count.toLocaleString() : ''}</td>
          <td className="text-right">{this.dropped_count(emailBroadcast).toLocaleString()}</td>
          <td className="text-left">
            <Link
              to={`/eblasts/${emailBroadcast.id}/emails?${Constants.DEFAULT_PAGINATION}`}
              className="btn btn-xs btn-default eblast_emails"
            >
              Details
            </Link>
          </td>
          <td>{this.cancelLink(emailBroadcast)}</td>
        </tr>
      );
    });
  }

  startTour() {
    this.setState({
      steps: EmailBroadcastsIndexTourSteps.tourSteps(),
      startTour: true
    });
  }

  render() {
    let count = 0;
    if (this.props.emailBroadcasts.meta) {
      count = this.props.emailBroadcasts.meta.count;
    }
    return (
      <div className="emailBroadcasts_index">
        <CompanyStatusCheck history={this.props.history}/>
        <Joyride
          run={this.state.startTour}
          continuous={true}
          steps={this.state.steps}
          showSkipButton={true}
          showProgress={true}
          scrollToSteps={false}
          callback={this.tourCallback.bind(this)}
        />
        <div className="row">
          <h1>
            eBlasts
            <button
              bsStyle="default"
              className="btn btn-sm btn-primary help_icon_smaller"
              onClick={this.startTour.bind(this)}
            >
              ?
            </button>
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                searchStr={this.state.search}
              />
            </div>
            <a
              href={`https://leads.realgeeks.com/leads?clear_search_except_filter=true`}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary pull-right add_lead_btn m-r-10"
            >
              Send a new eBlast from Lead Manager
            </a>
          </h1>
          <div className="alert alert-warning text-center alert-important-text">
            This page lists the eBlasts you have sent. &nbsp;
            <a
              href={`https://leads.realgeeks.com/leads?clear_search_except_filter=true`}
              target="_blank"
              rel="noopener noreferrer"
            >
              You can create a new eBlast from Lead Manager.
            </a>
          </div>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`email_broadcast_date ${this.indicateSorting(
                    "created_at"
                  )}`}
                  data-sort="created_at"
                  onClick={this.handleOrder.bind(this)}
                >
                  Sent Date
                </th>
                <th className={`email_broadcast_status`} data-sort="created_at">
                  Status
                </th>
                <th
                  className={`email_broadcast_name ${this.indicateSorting(
                    "name"
                  )}`}
                  data-sort="name"
                  onClick={this.handleOrder.bind(this)}
                >
                  Name
                </th>
                <th
                  className={`email_broadcast_subject ${this.indicateSorting(
                    "subject"
                  )}`}
                  data-sort="subject"
                  onClick={this.handleOrder.bind(this)}
                >
                  Subject
                </th>
                <th
                  className={`text-right email_stats_queued ${this.indicateSorting(
                    "sent_emails_count"
                  )}`}
                  data-sort="sent_emails_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Sent
                </th>
                <th
                  className={`text-right email_stats_delivered ${this.indicateSorting(
                    "delivered_count"
                  )}`}
                  data-sort="delivered_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Delivered
                </th>
                <th
                  className={`text-right email_stats_opened ${this.indicateSorting(
                    "opened_count"
                  )}`}
                  data-sort="opened_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Opens
                </th>
                <th
                  className={`text-right email_stats_clicked ${this.indicateSorting(
                    "clicked_count"
                  )}`}
                  data-sort="clicked_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Clicks
                </th>
                <th
                  className={`text-right email_stats_unsubscribed ${this.indicateSorting(
                    "unsubscribed_count"
                  )}`}
                  data-sort="unsubscribed_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Unsubs
                </th>
                <th
                  className={`text-right email_stats_spam_report ${this.indicateSorting(
                    "complained_count"
                  )}`}
                  data-sort="complained_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Spam R.
                </th>
                <th
                  className={`text-right email_stats_bounced ${this.indicateSorting(
                    "bounced_count"
                  )}`}
                  data-sort="bounced_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Bounces
                </th>
                <th
                  className={`text-right email_stats_failed ${this.indicateSorting(
                    "dropped_count"
                  )}`}
                  data-sort="dropped_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Failures
                </th>
                <th className="text-right" colSpan={2} />
              </tr>
            </thead>
            <tbody>{this.renderEmailBroadcasts()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { emailBroadcasts: state.emailBroadcasts.all };
}

export default connect(
  mapStateToProps,
  { fetchEmailBroadcasts, cancelEmailBroadcast }
)(EmailBroadcastsIndex);
